// composables/useGoogleAds.ts

import { IS_PROD } from "@/helpers/constants";

// Type definitions
interface ConversionData
  extends Record<
    string,
    string | number | boolean | Date | null | undefined | (() => void)
  > {
  send_to: string;
  value?: number;
  currency?: string;
  transaction_id?: string;
  event_callback?: () => void;
}

// Extend Window interface to include gtag
declare global {
  interface Window {
    gtag?: (
      command: "event" | "config" | "js",
      targetId: string | Date,
      config?: Record<
        string,
        string | number | boolean | Date | null | undefined
      >
    ) => void;
  }
}

export const useGoogleAds = () => {
  const trackConversion = (conversionData: ConversionData): void => {
    if (!IS_PROD) return;

    if (typeof window !== "undefined" && typeof window.gtag !== "undefined") {
      window.gtag(
        "event",
        "conversion",
        conversionData as Record<
          string,
          string | number | boolean | Date | null | undefined
        >
      );
    } else {
      console.warn("Google Analytics gtag not available");
    }
  };

  const trackPurchase = (value: number = 1000.0): void => {
    trackConversion({
      send_to: "AW-10964486997/h_j2COzgnIYbENWWo-wo",
      value,
      currency: "NGN",
      transaction_id: "",
    });
  };

  const trackInvoiceView = (value: number = 10000.0): void => {
    trackConversion({
      send_to: "AW-10964486997/AoFZCPLgnIYbENWWo-wo",
      value,
      currency: "NGN",
    });
  };

  const trackForm1Completion = (callback?: () => void): void => {
    const conversionCallback = (): void => {
      if (callback && typeof callback === "function") {
        callback();
      }
    };

    trackConversion({
      send_to: "AW-10964486997/GhreCPjgnIYbENWWo-wo",
      event_callback: conversionCallback,
    });
  };

  const trackForm2Completion = (callback?: () => void): void => {
    const conversionCallback = (): void => {
      if (callback && typeof callback === "function") {
        callback();
      }
    };

    trackConversion({
      send_to: "AW-10964486997/bxFvCPXgnIYbENWWo-wo",
      event_callback: conversionCallback,
    });
  };

  return {
    trackPurchase,
    trackInvoiceView,
    trackForm1Completion,
    trackForm2Completion,
    trackConversion,
  } as const;
};

// Export types for use in components
export type { ConversionData };
